// src/utils/deliveryShare.js
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

function generateShareId(length = 12) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

/**
 * Create a shareable link for a delivery.
 * @param {string} deliveryId
 * @param {object} deliveryData
 * @param {string|null} organizationId - Used to route new sign-ups into the right org
 */
export async function createDeliveryShare(deliveryId, deliveryData) {
  const shareId = generateShareId();

  const shareData = {
    deliveryId,
    shareId,
    createdAtMs: Date.now(),

    // Organization — routes unauthenticated users to /create-user?organization=X
    organizationId: deliveryData.organizationId ?? null,

    // Addresses as plain strings
    origin:      deliveryData.origin      ?? deliveryData.from ?? null,
    destination: deliveryData.destination ?? deliveryData.to   ?? null,

    originInfo: deliveryData.originInfo      ?? deliveryData.fromInfo ?? null,
    distance:   deliveryData.distance      ? Number(deliveryData.distance) : null,

    // Times — unix millis
    pickupTime: deliveryData.pickupTime ?? deliveryData.pickUpTime ?? null,
    targetTime: deliveryData.targetTime ?? null,

    // Payment
    reward: deliveryData.reward ? Number(deliveryData.reward) : 0,

    // Type
    deliveryType:          deliveryData.deliveryType          || null,
    deliveryTransportType: deliveryData.deliveryTransportType || null,

    // Flags
    urgent:             deliveryData.urgent             || false,
    returnParcels:      deliveryData.returnParcels      || false,
    returnMethod:       deliveryData.returnParcels ? (deliveryData.returnMethod ?? null) : null,
    temperatureControl: deliveryData.temperatureControl || false,
  };

  await setDoc(doc(db, 'deliveryShares', shareId), shareData);
  return shareId;
}

export async function getSharedDelivery(shareId) {
  try {
    const shareSnap = await getDoc(doc(db, 'deliveryShares', shareId));
    if (!shareSnap.exists()) return null;
    return shareSnap.data();
  } catch (error) {
    console.error('Error fetching shared delivery:', error);
    return null;
  }
}

export function getShareUrl(shareId) {
  return `${window.location.origin}/kuljeta/${shareId}`;
}